import React, {
    memo,
    useState,
} from 'react';

import Preloader from 'components/Preloader';
import EmptyContent from 'components/EmptyContent';

import { CustomTable } from 'components/CustomTable';
import Card from 'components/Card/Card';
import { useTranslation } from 'react-i18next';

import { useGetInvestmentApplications } from 'hooks/useGetInvestmentApplications';
import { investmentApplicationsAdapter } from './investmentApplicationsAdapter';
import {
    DEFAULT_PAGE_SIZE,
    columns,
} from './constants/const';

const BusinessCase = () => {
    const { t } = useTranslation();
    const tableColumns = columns(t);

    const [investmentAppPageNumber, setInvestmentAppPageNumber] = useState(1);

    const {
        isLoading: isInvestmentApplicationsLoading,
        error: investmentApplicationsError,
        totalPages,
        data: applications,
    } = useGetInvestmentApplications({
        pageNumber: investmentAppPageNumber,
        adapter: investmentApplicationsAdapter,
    });

    return (
        <Card title={t('dashboard.agentCockpit.overviewClientApplications')}>
            <Preloader isLoading={isInvestmentApplicationsLoading} error={investmentApplicationsError}>
                <EmptyContent data={applications} text="Not Found">
                    <CustomTable
                        columns={tableColumns}
                        data={applications}
                        onChange={setInvestmentAppPageNumber}
                        paging={{
                            pageSize: DEFAULT_PAGE_SIZE,
                            pageNumber: investmentAppPageNumber,
                            totalPages,
                        }}
                    />
                </EmptyContent>
            </Preloader>
        </Card>
    );
};

export default memo(BusinessCase);
